import { labelFields, labelFieldsDisplayNames } from "../../../constants/NauticalObjects";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
import "./LabelControl.css";

interface LabelControlProps {
    enabledFields: string[];
    setEnabledFields: React.Dispatch<React.SetStateAction<string[]>>;
    labelsEnabled: boolean;
    onApplyLabels: () => void;
    onRemoveLabels: () => void;
}
const LabelControl = ({
    enabledFields,
    setEnabledFields,
    labelsEnabled,
    onApplyLabels,
    onRemoveLabels,
}: LabelControlProps) => {
    return (
        <div className="label-control">
            <span>
                Her kan du velge hvilke felter som skal vises som etiketter i kartet. Feltene finnes på tvers av de
                nautiske objektene og vil vises dersom de finnes. Bruk knappene under for å slå på eller av feltene.
            </span>
            <div className="label-buttons">
                {labelFields.map((field) => {
                    return (
                        <NfsButton
                            key={field}
                            inverted
                            outlined
                            className="h-stretch"
                            active={enabledFields.includes(field)}
                            onClick={() => {
                                if (enabledFields.includes(field)) {
                                    setEnabledFields(enabledFields.filter((f) => f !== field));
                                } else {
                                    setEnabledFields([...enabledFields, field]);
                                }
                            }}
                        >
                            {labelFieldsDisplayNames[field] || field}
                        </NfsButton>
                    );
                })}
            </div>
            <div className="label-control-actions">
                <NfsButton outlined active={!labelsEnabled} onClick={onRemoveLabels}>
                    Fjern etiketter
                </NfsButton>
                <NfsButton active={labelsEnabled} onClick={onApplyLabels}>
                    Bruk etiketter
                </NfsButton>
            </div>
        </div>
    );
};

export default LabelControl;
